module.exports = __webpack_public_path__ + "img/bear8.b814c43b.png";